import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	padding: 30px 30px 0 30px;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	width: 822px;
`;

const StyledTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	width: fit-content;
	height: 30px;
	padding: 0 10px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledItemsList = styled.div`
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	grid-auto-rows: 110px;
	gap: 20px;
	height: 548px;
	overflow-y: scroll;
	margin-top: 30px;
	padding-bottom: 30px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export { StyledContainer, StyledItemsList, StyledTitle };
